import type { PropsWithChildren } from 'react';
import React from 'react';
import cn from 'classnames';
import * as styles from './styles.module.css';

// задает максимальную ширину в 1280рх или сколько там будет в переменной --layout-max-width
// используется в хедере и в контентной части для страниц (кроме редактора)
export function BaseContainer({
  children,
  className = '',
}: PropsWithChildren<{ className?: string }>) {
  return <div className={cn([styles.baseContainer, className])}>{children}</div>;
}
